let ctx: AudioContext | null = null;

/** Short beep + vibration: high = success, low = problem. */
export function feedback(ok: boolean) {
  try {
    ctx ??= new AudioContext();
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    o.frequency.value = ok ? 1200 : 320;
    g.gain.value = 0.12;
    o.connect(g).connect(ctx.destination);
    o.start();
    o.stop(ctx.currentTime + (ok ? 0.08 : 0.28));
  } catch {
    /* audio blocked */
  }
  try {
    navigator.vibrate?.(ok ? 50 : [80, 60, 80]);
  } catch {
    /* not supported */
  }
}
